export * from '@egovsolutions/angular-egov-api/ppt/internal/basic-models';

const PPT_BILL_CART_ITEM_TYPE = 'ppt';

/**
 * Generated bundle index. Do not edit.
 */

export { PPT_BILL_CART_ITEM_TYPE };
